import { AxiosAcquisitionRepository } from '../../interface_adapters/services/AxiosAcquisitionRepository';
import { AcquisitionService } from '../../interface_adapters/services/AcquisitionService';
import { ABTesting } from '../../frameworks_drivers/redux/reducers/abTest/abTesting';
import { MiscStoreData } from '../../frameworks_drivers/redux/reducers/miscellaneous/miscSlice';

const acquisitionService = new AcquisitionService(new AxiosAcquisitionRepository());

export function createNewOrder(storeData: any, abTesting: ABTesting, miscData: MiscStoreData) {
  return acquisitionService.createOrder(storeData, abTesting, miscData);
}

export function createNewLead(storeData: any, abTesting: ABTesting, miscData: MiscStoreData) {
  return acquisitionService.createLead(storeData, abTesting, miscData);
}

export function getLeadById(leadId: string, key: string) {
  return acquisitionService.getLeadById(leadId, key);
}

export function convertLeadToOrder(
  leadId: string,
  orderConfirmationKey: string,
  dataProcessingAgreementVersion: string
) {
  return acquisitionService.convertLeadToOrder(
    leadId,
    orderConfirmationKey,
    dataProcessingAgreementVersion
  );
}
